import { Response, ResponseCostInfo } from './type';
import { getCookieTokenInfo } from '../TokenMgmt';
import browser from '../browser';
import { getLanguage } from '../language';
import { AxiosStatic } from 'axios';

/** 添加costInfo到响应数据中 */
const addResponseCostInfo = (
  response: Response,
  costInfo: ResponseCostInfo | string,
  url: string,
) => {
  const { data } = response;
  if (data && typeof data === 'object' && !Array.isArray(data)) {
    // 如果数据是对象，挂载到data上
    data._costInfo = costInfo;
    return;
  }

  // 如果数据不是对象，挂载到window上，key为url，3s后移除
  let key: string | null = `_costInfo_${url}`;
  window[key] = costInfo;
  setTimeout(() => {
    delete window[key as string];
    key = null; // 释放key
  }, 3000);
};

const popupClass = 'ovopark-cost-popup';
const style = `
<style>
  .${popupClass} {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 9999999;
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, 0.5);
  }
  .${popupClass}__popup {
    position: absolute;
    top: 50%;
    left: 50%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 48vw;
    height: 27vw;
    min-width: 284px;
    min-height: 160px;
    max-width: 853px;
    max-height: 480px;
    background: #fff;
    border-radius: 12px; 
    overflow: hidden;
    transform: translate(-50%, -50%);
    user-select: none;
  }
  .${popupClass}__popup svg {
    position: absolute;
    top: 0;
    left: -4%;
    z-index: -1;
    height: 100%;
  }
  .${popupClass}__close {
    position: absolute;
    top: 8px;
    right: 8px;
    z-index: 3;
    width: 24px;
    height: 24px;
    line-height: 1;
    color: #7f7f7f;
    font-size: 24px;
    font-weight: 200;
    text-align: center;
    cursor: pointer;
    &:hover {
      color: #f11;
    }
  }
  .${popupClass}__text {
    padding: 0 32px;
    color: #000;
    font-size: 16px;
  }
  .${popupClass}__text2 {
    padding: 0 32px;
    margin-top: 16px;
    color: #7f7f7f;
    font-size: 14px;
  }
  .${popupClass}__button {
    padding: 9px 24px;
    margin-top: 24px;
    line-height: 1;
    color: #fff;
    font-size: 14px;
    font-weight: 500;
    text-align: center;
    background: linear-gradient(180deg,#ffd179 0%,#ff9900 100%);
    border-radius: 16px;
    box-shadow: 0px -2px 2px #ff8900 inset;
    cursor: pointer;
  }
</style>
`;
const svg =
  '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 1060 484"><defs><linearGradient id="b" x1="25.319%" x2="50%" y1="44.305%" y2="68.281%"><stop offset="0%" stop-color="#FFFBF5"/><stop offset="100%" stop-color="#FFF3E1"/></linearGradient><linearGradient id="d" x1="22.609%" x2="56.774%" y1="42.674%" y2="64.202%"><stop offset="0%" stop-color="#FFFBF5"/><stop offset="100%" stop-color="#FFF3E1"/></linearGradient><path id="a" d="M0 0h1060v484H0z"/></defs><g fill="none" fill-rule="evenodd"><mask><use xlink:href="#a"/></mask><path fill="url(#b)" fill-rule="nonzero" d="m732.604-165.14 84.815 84.891-249.632 249.34c-22.646 22.626-59.342 22.626-81.988 0L236.604-79.812l84.815-84.89L507.001 20.682c10.933 10.923 28.648 10.923 39.58 0l186.023-185.821" mask="url(#c)"/><path fill="url(#d)" fill-rule="nonzero" d="m992.36-169.18 113.303 112.971-508.297 509.796c-38.995 39.11-102.312 39.202-141.422.208l-.208-.208L-51.64-55.285l113.303-112.97 394.072 395.234c38.995 39.11 102.311 39.203 141.421.208l.208-.208L992.36-169.18" mask="url(#c)"/></g></svg>';

const locale = {
  'zh-CN': {
    text: '服务到期，立即前往续费',
    text2: '请前往网页端【费用中心】续费',
    button: '费用中心',
  },
  'zh-TW': {
    text: '服務到期，立即前往續費',
    text2: '請前往網頁端【費用中心】續費',
    button: '費用中心',
  },
  'en-US': {
    text: 'Service expired, please go to renew',
    text2: 'Please go to the web [Cost Center] to renew',
    button: 'Cost Center',
  },
  'id-ID': {
    text: 'Layanan kadaluarsa, silakan pergi untuk memperpanjang',
    text2: 'Silakan pergi ke web [Pusat Biaya] untuk memperpanjang',
    button: 'Pusat Biaya',
  },
  'ja-JP': {
    text: 'サービス期限切れ、すぐに更新に行ってください',
    text2: 'ウェブ【費用センター】にアクセスして更新してください',
    button: '費用センター',
  },
  'it-IT': {
    text: 'Servizio scaduto, vai al centro dei costi',
    text2: 'Vai al web [Centro dei Costi] per aggiornare',
    button: 'Centro dei Costi',
  },
  'th-TH': {
    text: 'บริการหมดอายุ กรุณาไปที่ศูนย์ค่าใช้จ่าย',
    text2: 'ไปที่เว็บ [ศูนย์ค่าใช้จ่าย] เพื่ออัปเดต',
    button: 'ศูนย์ค่าใช้จ่าย',
  },
  'vi-VN': {
    text: 'Dịch vụ hết hạn, vui lòng đi đến trung tâm chi phí',
    text2: 'Vào web [Trung tâm chi phí] để cập nhật',
    button: 'Trung tâm chi phí',
  },
};

let timer: NodeJS.Timeout | null = null;

/** 添加过期提示 */
export const addExpiredTip = async (costInfo: ResponseCostInfo, axios: AxiosStatic) => {
  console.log('🚀 ~ addExpiredTip ~ costInfo:', costInfo);
  let wrapper = document.querySelector(`.${popupClass}`);
  if (wrapper) {
    return;
  }

  // 获取语言
  const i18n = locale[getLanguage() as keyof typeof locale] || locale['zh-CN'];

  // 创建弹窗容器
  wrapper = document.createElement('div');
  wrapper.setAttribute('class', popupClass);
  // 弹窗
  const popup = document.createElement('div');
  popup.setAttribute('class', popupClass + '__popup');
  popup.innerHTML = style + svg;
  // 关闭按钮
  const closeBtn = document.createElement('span');
  closeBtn.setAttribute('class', popupClass + '__close');
  closeBtn.innerHTML = '×';
  closeBtn.addEventListener('click', removeExpiredTip);
  popup.appendChild(closeBtn);
  // 提示文本
  const text = document.createElement('div');
  text.setAttribute('class', popupClass + '__text');
  text.innerHTML = i18n.text;
  popup.appendChild(text);

  if ((browser.ovopark && window.ovopark) || !browser.mobile) {
    // App内或非移动端，根据权限 显示 费用中心按钮
    if (await checkCostCenterPermission(axios)) {
      const button = document.createElement('div');
      button.setAttribute('class', popupClass + '__button');
      button.innerHTML = i18n.button;
      button.addEventListener('click', () => gotoCostCenter());
      popup.appendChild(button);
    }
  } else {
    // 移动端，显示到网页端操作
    const text2 = document.createElement('div');
    text2.setAttribute('class', popupClass + '__text2');
    text2.innerHTML = i18n.text2;
    popup.appendChild(text2);
  }

  wrapper.appendChild(popup);
  // 添加到页面
  document.querySelector('body')!.appendChild(wrapper!);
};

/** 移除过期提示 */
const removeExpiredTip = () => {
  let wrapper = document.querySelector(`.${popupClass}`);
  if (wrapper) {
    wrapper.remove();
    wrapper = null;
  }
};

/** 检查费用中心权限 */
const checkCostCenterPermission = async (axios: AxiosStatic) => {
  try {
    const userInfo = JSON.parse(sessionStorage.getItem('userInfo') || '{}');
    const userId = userInfo.data.id;
    if (userId) {
      const token = getCookieTokenInfo().token;
      if (token) {
        const res = await axios.get(`/api/crm/cost/app/v1/getUserCostAuth?id=${userId}`, {
          headers: {
            'ovo-authorization': token,
          },
        });
        return Boolean(res.data?.data?.hasAuth);
      }
    }
    return false;
  } catch (error) {
    return false;
  }
};

/**
 * 费用中心校验
 * @param response 响应数据
 * @param url 请求url
 */
export const costValidate = (
  response: Response,
  url: string,
  axios: AxiosStatic,
  ignoreCostTip?: boolean,
) => {
  if (response.costInfo) {
    let costInfo: ResponseCostInfo | string = response.costInfo;
    if (typeof response.costInfo === 'string') {
      try {
        costInfo = JSON.parse(response.costInfo) as ResponseCostInfo;
      } catch (error) {
        // 转化失败，costInfo 保持原样
      }
    }
    if (typeof costInfo === 'object') {
      // 显示服务到期提示，若请求参数 ignoreCostTip 为 true，则不显示
      if (costInfo.isExpired && !ignoreCostTip) {
        const delay = (costInfo.allowDuration ?? 0) > 0 ? costInfo.allowDuration! : 0; // 延迟时间，单位：秒
        if (timer) {
          clearTimeout(timer);
          timer = null;
        }
        timer = setTimeout(() => {
          timer = null;
          addExpiredTip(costInfo, axios);
        }, delay * 1000);
      }
    }
    // 添加costInfo到响应数据中
    addResponseCostInfo(response, costInfo, url);
  }
};

/** 跳转费用中心 */
export const gotoCostCenter = (params?: { blank?: boolean }) => {
  console.log('跳转费用中心, params:', params);
  const token = getCookieTokenInfo().token;
  const isDev = window.location.host.includes('test') || window.location.host.includes('local'); // 是否是开发环境
  if (browser.ovopark && window.ovopark) {
    // 万店掌App内，打开原生费用中心
    window.ovopark.action('openAppPage', { module: 'CRM_EXPENSE_CENTER' });
    removeExpiredTip();
  } else if (browser.mobile) {
    // 移动端
    // const url = `https://tiantih5.${
    //   isDev ? 'wandianzhang' : 'ovopark'
    // }.com/notice/serviceSubDetail?token=${token}`;
    // if (params?.blank) {
    //   window.open(url, '_blank');
    // } else {
    //   location.href = url;
    // }
  } else {
    // web端
    const url = `https://cost.${
      isDev ? 'wandianzhang' : 'ovopark'
    }.com/#/costCenter/charge?token=${token}`;
    if (params?.blank) {
      window.open(url, '_blank');
    } else {
      location.href = url;
    }
  }
};
